export { default as AcademicInformation } from "./AcademicInformation/AcademicInformation";
export { default as BasicInformation } from "./BasicInformation/BasicInformation";
